<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <div v-if="!current.refundEligibility.isFetched">
      <SoSkeleton :height="64" />
      <SoSkeleton :type="['list-item-three-line', 'button']" />
    </div>
    <SoFlow
      v-else
      :workflow-id="FlowType.RefundReview"
      :account-number="current.accountNumber"
      :start-step="startStep"
      title="Refund Review"
      data-testid="refund-review-flow"
      @closed="flowClosed"
    />
    <template #sidePanel>
      <CustomerAccountInfoPanel />
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail />
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import { FlowType } from "@/flows/useCases"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useReviewPaymentStore } from "@/stores/reviewPayment"
  import { CreditRefundMutator } from "@/mutators/creditRefund/CreditRefundMutator"
  import { RefundIssue } from "@/services-handlers/getRefundEligibility"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "@/views/customer/overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "@/views/customer/overview/CustomerAccountInfoRail.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoFlow,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoSkeleton,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        reviewPayment: useReviewPaymentStore(),
        creditRefund: CreditRefundMutator.creditRefund,
        FlowType,
      }
    },
    computed: {
      startStep() {
        if (
          this.current.refundEligibility.data.toResolve.length === 1 &&
          this.current.refundEligibility.data.toResolve.includes(
            RefundIssue.ACCOUNT_BALANCE_TOO_LOW,
          )
        ) {
          return "refundPolicyCheck"
        } else if (this.current.refundEligibility.data.toResolve.length) {
          return "issuesToResolve"
        }
        return "refundReview"
      },
    },
    methods: {
      flowClosed() {
        this.reviewPayment.reset()
        this.$router.push({
          name: "CustomerFinancials",
        })
      },
    },
  })
</script>
